import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { withdrawModalConfig } from '../modals/withdrawModalConfig';
import { proposalRowActions } from './useProposalRowActions.utils';
export function useProposalRowActions() {
    const { t: texts } = useLocaleKeys('proposal.dashboard');
    const { EDIT_PROPOSAL_IN_PLACE } = useFeatureFlags();
    const overlayContext = useOverlayContext();
    return useCallback((args)=>proposalRowActions(_object_spread_props(_object_spread({}, args), {
            texts,
            editInPlaceEnabled: EDIT_PROPOSAL_IN_PLACE === true,
            onWithdraw: (param)=>{
                let { relationshipId, draftId } = param;
                return overlayContext.showModal(withdrawModalConfig({
                    relationshipId,
                    draftId
                }));
            }
        })), [
        EDIT_PROPOSAL_IN_PLACE
    ]);
}
